import React, { useEffect } from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import AdminHome from "./pages/Home/AdminHome";
import Login from "./pages/Login/Login";
import PrivacyQuestions from "./pages/PrivacyQuestions/PrivacyQuestions";
import LettersAndReports from "./pages/LettersAndReports/LettersAndReports";
import Contact from "./pages/Contact/Contact";
import Register from "./pages/Register/Register";
import Deposits from "./pages/Deposits/Deposits";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import background from "./assets/images/background.png";
import FullScreenModal from "./components/Modal/Modal";
import ScrollToTop from "./customHooks/ScrollToTop";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import AmitPrivateRoute from "./components/PrivateRoute/AmitPrivateRoute";
import PersonalDetails from "./pages/PersonalDetails/PersonalDetails";
import useAutoLogout from "./components/Idle/Idle";
import { useDispatch, useSelector } from "react-redux";
import { setModalChild, setModalState } from "./state/actions/modalAction";
import TimeOutPopUp from "./components/TimeOutPopUp/TimeOutPopUp";
import { resetUser } from "./state/actions/UserActions";
import { LogOut } from "./services/LogOut";
import { resetTokenData, isUserAuthExpired } from "./middleware/DAL";
import UserFund from "./entities/UserFund";
import { setActiveFund } from "./state/actions/DashboardActions";
import { useTranslation } from "react-i18next";
import "./App.scss";
import { Console } from "console";


function App() {
  const { t, i18n } = useTranslation("common");
  const timer = useAutoLogout(10 * 60);
  const dispatch = useDispatch();
  const { isOnline } = useSelector((state: any) => state.UserReducer);

  useEffect(() => {
    // perform logout when user already signed in, in same tab and navigated to the app
    if (window.performance) {
      const navigation: any = performance.getEntriesByType("navigation")[0];
      const isPageRefreshed = navigation?.type === "reload";

      if (!isPageRefreshed && isUserAuthExpired()) {
        dispatch(resetUser());
        dispatch(setActiveFund({} as UserFund));
        resetTokenData();
      }
    }
  }, []);

  useEffect(() => {
    if (timer <= 0) handleAutoLogOut();
  }, [timer]);

  useEffect(() => {
    if(i18n.language == undefined || localStorage.getItem("lang") == undefined ){
      localStorage.setItem("lang", "he")
      i18n.changeLanguage("he");
    } 
    if(process.env.REACT_APP_ENVIRONMENT_INFO === "testinternal" || process.env.REACT_APP_ENVIRONMENT_INFO === "prodinternal"){
            console.log('VERSION::',process.env.REACT_APP_VERSION)
    }
  }, []);

  const handleAutoLogOut = () => {
    if (isOnline) autoLogOut();
    else moveToLoginPage();
  };

  const autoLogOut = () => {
    dispatch(resetUser());
    dispatch(setActiveFund({} as UserFund));
    openTimeOutPopup();
    const refreshTokenNum = sessionStorage.getItem("refreshTokenNum");
    if (!refreshTokenNum) return;
    LogOut(refreshTokenNum);
  };

  const moveToLoginPage = () => {
    const path = window.location.pathname;
    if (!path.match("login")) {
      openTimeOutPopup("/login");
    } else {
      const loginUniqueElement = document.getElementById("login-element");
      if (!loginUniqueElement) {
        // we cant move user directly to login when user already in login..
        // so - move to auth route, user is not logged in so he will move to login page.
        openTimeOutPopup("/reports");
      }
    }
  };

  
  
  const path = window.location.pathname;
  let checkout
  useEffect(() => {
     checkout = path?.includes('login' ) || path?.includes('register' )|| path?.includes( 'privacy-questions');
  },[path]);
  

  const openTimeOutPopup = (redirectUrl?: string) => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <TimeOutPopUp
          redirectUrl={redirectUrl}
          label={"label"}
          subLabel={"subLabel"}
          buttonText={"buttonText"}
          size="m"
          center={true}
        />
      )
    );
  };

  return (
    <div className="app background-image" id="app" role="contntinfo" dir="rtl">
        <div className='goto'>
          <a href="#main" className='goto-link'>{t("general.gotoMain")}</a>
        </div>
      {!checkout ?<div className="blueCircle"></div> : null}
      {!checkout ?<div className="grayCircle"></div>  : null}
      {/* @ts-ignore:next-line */}
      <Router basename="/Online" role="contentinfo">
        <ScrollToTop />
        <Header />
        {/* @ts-ignore:next-line */}
        <Switch>
          <PrivateRoute exact path="/">
            <Home /> 
          </PrivateRoute>
          <PrivateRoute exact path="/reports">
            <LettersAndReports />
          </PrivateRoute>
          <PrivateRoute exact path="/contact">
            <Contact />
          </PrivateRoute>
          <AmitPrivateRoute exact path="/deposits">
            <Deposits />
          </AmitPrivateRoute>
          <PrivateRoute exact path="/my-details">
            <PersonalDetails />
          </PrivateRoute>
          {/* @ts-ignore:next-line */}
          <Route exact path="/login/:goto?" component={Login} />
          {/* @ts-ignore:next-line */}
          <Route exact path="/register" component={Register} />
          {/* @ts-ignore:next-line */}
          <Route exact path="/privacy-questions" component={PrivacyQuestions} />
          {/* @ts-ignore:next-line */}
          {process.env.REACT_APP_ENVIRONMENT_INFO === "testinternal" || process.env.REACT_APP_ENVIRONMENT_INFO === "prodinternal" ?
           <Route exact path="/Dashboard/:tokenNum?/:refreshTokenNum?/:tokenExpiryDate?/:refreshTokenExpiryDate?" component={AdminHome} />:null}
          <Route
            path="/*"
            render={({ location }) => 
            (/* @ts-ignore:next-line */
              <Redirect 
                to={{
                  pathname: "/",
                  state: { from: location },
                }}
              />
            )}
          />
        </Switch>
        <Footer />   
        <FullScreenModal />
      </Router>
    </div>
  );
}

export default App;
